<template>
  <div v-if="isSample" class="workflow-job-item sample">
    <i class="ddi ddi-navigation-menu hidden" />
    <div class="workflow-job-item__item-editor">
      <input class="bluish-grey no-border" maxlength="50">
    </div>
  </div>
  <div v-else :class="{'read-only': readOnly}" class="workflow-job-item">
    <i :class="{'hidden': !showDrag || readOnly}" class="ddi ddi-navigation-menu handle"/>
    <div class="workflow-job-item__item-editor">
      <input 
        ref="nameInput" 
        v-model="job.name" 
        :tabindex="index+1" 
        placeholder="Name job (e.g. fixer, tester)..." 
        maxlength="50"
      >
    </div>
    <div class="workflow-job-item__options">
      <i v-if="showDelete" class="ddi ddi-trash" @click="handleDeleteClick(index)" />
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IJob } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'WorkflowJobItem',

  props: {
    index: {
      type: Number,
      default: -1,
    },
    job: {
      type: Object as () => IJob,
      required: true,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    showDrag: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isSample: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    focusOnCreate: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['delete-clicked'],

  data() {
    return {
      ColorAssistant,
      TextAssistant,
    }
  },

  created() {
    if (this.focusOnCreate) {
      this.$nextTick(() => {
        // @ts-ignore
        this.$refs.nameInput.focus()
      })
    }
  },

  methods: {
    handleDeleteClick(index: number) {
      if (!this.showDelete) {
        return
      }
      this.$emit('delete-clicked', index)
    },
  },
})
</script>

<style lang="scss">
.workflow-job-item {
  width: 100%;
  border: $border--dotted-medium;
  margin-bottom: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  background-color: var(--color-background-primary);
  @include flex-row-horizontal-spacing(8px);
  @include standard-box-shadow;

  &.read-only {
    pointer-events: none;
  }

  &.sample {
    opacity: 0.4;
    * {
      pointer-events: none;
    }

    .workflow-status-color-picker > div {
      background-color: $color--gray-60 !important;
    }
  }

  .ddi {
    cursor: pointer;
    font-size: 18px;
    color: var(--color-text-primary);

    &.hidden {
      opacity: 0;
      cursor: default;
    }
  }

  > .ddi-navigation-menu {
    @include clickable-gray-color-states;
    cursor: grab;
  }

  &__item-editor {
    display: flex;
    align-items: center;
    flex-grow: 1;
    @include flex-row-horizontal-spacing(8px);

    input {
      max-width: 240px;
      flex-grow: 1;
      border-radius: 6px;
      outline: none;
      border: $border--solid-medium;
      @include lettering--p-sm;
      font-weight: $bold;
      padding: 4px 6px;

      @include media-breakpoint-down(sm) {
        width: 100%;
      }
    }
  }

  &__options {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @include flex-row-horizontal-spacing(10px);

    > .ddi {
      @include clickable-gray-color-states;
    }
  }
}
</style>
